










import { Vue, Component, Prop } from 'vue-property-decorator';
import { routeHelper } from '../../utils/routeHelper';

@Component
export default class MenuButton extends Vue {
  @Prop()
  title!: string;

  @Prop()
  toName!: string;

  next() {
    routeHelper(this, this.toName);
  }
}
